import { defineComponent, h, useAttrs } from 'vue'

export default defineComponent({
  name: 'VStepperCompat',
  compatConfig: {
    RENDER_FUNCTION: false,
    COMPONENT_V_MODEL: false,
    INSTANCE_ATTRS_CLASS_STYLE: false
  },
  inheritAttrs: false,

  setup(_, { slots }) {
    const attrs = useAttrs()

    return () =>
      h(
        'div',
        {
          ...attrs,
          class: [
            'v-stepper',
            attrs.vertical != null ? 'v-stepper--vertical' : null,
            attrs.class
          ]
        },
        slots.default?.()
      )
  }
})
